<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('chat-bots') }} -> {{ $t('list-groups') }}
    </h1>
    <div class="main__body">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">{{ $t('group-name') }}</th>
          <th scope="col">{{ $t('count-player') }}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in groups" v-bind:key="item.id">
          <th scope="row">
            {{ index + 1}}
          </th>
          <td>{{ item.name }}</td>
          <td>{{ item.countManager }}</td>
          <td class="col-action">
            <img class="pointer" src="@/assets/icon/edit.svg" @click="viewGroup(item.id)">
            <img class="pointer" src="@/assets/icon/trash.svg" @click="deleteGroup(item.id, item.name)">
          </td>
        </tr>
        </tbody>
      </table>
      <div class="form-row mt-1">
        <router-link class="btn btn-primary" to="/create-group-manager">{{ $t('create-new-group-managers') }}</router-link>
      </div>
    </div>
    <remove-manager-group :group="this.group"
                               v-show="isModalRemoveGroupManager" @close="closeModalRemoveGroupManager">
    </remove-manager-group>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import RemoveManagerGroup from "../components/modal/group/remove-manager-group";
export default {
  name: 'list-group-manager',
  data: function(){
    return{
      group: {
        id: 0,
        name: ''
      },
      groups: [],
      errors: [],
      isModalRemoveGroupManager: false,
      isLoading: false,
      fullPage: true
    }
  },
  created: function(){
    this.getGroups();
  },
  mounted() {
    this.$root.$on('updateListGroupManager', () => {
      this.getGroups();
    });
  },
  methods: {
    viewGroup: function(id){
      this.$router.push({
        path: `/view-group-manager/${id}`
      });
    },
    getGroups: function(){
      this.isLoading = true;
      axios.post('getListGroupManager').then(response => {
        var status = response.data.status;
        if(status){
          this.groups = response.data.groups;
          this.isLoading = false;
        }
      });
    },
    deleteGroup: function(id, name){
      this.group.id = id;
      this.group.name = name;
      this.showModalRemoveGroupManager();
    },
    showModalRemoveGroupManager() {
      this.isModalRemoveGroupManager = true;
    },
    closeModalRemoveGroupManager() {
      this.isModalRemoveGroupManager = false;
    }
  },
  components: {
    RemoveManagerGroup, loading
  }
}
</script>